import { SanityHeadingSection } from "@sourceful/shared-types/src/sanity/layouts/headingSection";
import BasePageSection from "../BasePageSection";

interface HeadingSectionProps {
  section: SanityHeadingSection;
}

export const HeadingSection = ({ section }: HeadingSectionProps) => {
  return <BasePageSection section={section} minHeight={"auto"}></BasePageSection>;
};

export default HeadingSection;
